import { useState } from 'react';
import { PayoutListFilter } from '@frontend/api-payouts';
import { TableFilter } from '../../TableFilter';
import { PayoutsFilterMenu } from './payout-filter-menu';

const hasFilter = (filter?: PayoutListFilter) => !!(filter?.amount || filter?.status || filter?.arrival);

export type PayoutFilterProps = {
  initialFilter: PayoutListFilter;
  onApply: (filter: PayoutListFilter) => void;
  payoutDescriptors: string[];
};

export const PayoutFilter = ({ initialFilter, onApply, payoutDescriptors, ...rest }: PayoutFilterProps) => {
  const [showNotification, setShowNotification] = useState(hasFilter(initialFilter));

  const handleOnApply = (filter: PayoutListFilter) => {
    setShowNotification(hasFilter(filter));
    onApply(filter);
  };

  return (
    <TableFilter showNotification={showNotification} data-trackingid='pay-portal-payouts-btn-filter' {...rest}>
      <TableFilter.Body>
        <PayoutsFilterMenu
          initialFilter={initialFilter}
          onApply={handleOnApply}
          payoutDescriptors={payoutDescriptors}
        />
      </TableFilter.Body>
    </TableFilter>
  );
};
